import { Injectable } from '@angular/core';
import { first } from 'rxjs/operators';

import { UserRoleType } from '@vi-iot/client';

import { AuthStore, MeUserDetails } from '@store';
import { MatDialog } from '@angular/material/dialog';
import { InstallationMigrationModalComponent } from './installation-migration-modal/installation-migration-modal.component';

@Injectable({
  providedIn: 'root',
})
export class InstallationsMigrationService {
  private canUserAccessInstallationsMigration: boolean;

  constructor(private authStore: AuthStore, private dialog: MatDialog) {
    this.setInstallationMigrationAccess();
  }

  openMigrationModal(): void {
    this.dialog.open(InstallationMigrationModalComponent, {
      width: '767px',
      panelClass: 'installations-migration-modal',
      data: {},
      autoFocus: false,
      disableClose: true,
    });
  }

  isUserPermittedToMigrateInstallation(): boolean {
    return this.canUserAccessInstallationsMigration;
  }

  private setInstallationMigrationAccess(): void {
    this.authStore.me$.pipe(first()).subscribe((authDetails: MeUserDetails) => {
      const hasLocalWritePermissions = authDetails.iotRole === UserRoleType.supportLocalReadWrite;
      const hasLocalWriteWithRemoteDiagnosisPermissions =
        authDetails.iotRole === UserRoleType.supportLocalReadWriteWithRemoteDiagnosis;
      const isSupportLocalDepartmentManagement =
        authDetails.iotRole === UserRoleType.supportLocalDepartmentManagement;
      const isInternationalSupport = authDetails.iotRole === UserRoleType.supportInternational;
      const isInternationalWithRemoteDiagnosisSupport =
        authDetails.iotRole === UserRoleType.supportInternationalWithRemoteDiagnosis;

      this.canUserAccessInstallationsMigration =
        hasLocalWritePermissions ||
        hasLocalWriteWithRemoteDiagnosisPermissions ||
        isInternationalSupport ||
        isSupportLocalDepartmentManagement ||
        isInternationalWithRemoteDiagnosisSupport;
    });
  }
}
